import ConsentRequiredView from './ConsentRequiredView';

export { CONSENT_TYPE_COOKIES, CONSENT_TYPE_EMAIL } from './ConsentRequiredView';

export { default as useConsentSettings } from './useConsentSettings';

export default ConsentRequiredView;
